import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import {
  Grid,
  Chip as MuiChip,
  Divider as MuiDivider,
  Typography,
  Stack,
} from "@mui/material";
import { toast } from "react-toastify";

import {
  renderColumnDataGrid,
  getSubFormContrlsObj,
  saveSubFormRow,
  deleteSubFormRow,
  parseAndRound,
} from "src/utils/amUtils";
// import AMFooterTable from "src/pages/components/AMFooterTable";
import AMFooterTable from "src/pages/components/AMFooterTableByDataGrid";
import * as Enums from "src/utils/enums";
import useForm from "src/hooks/useForm";
import FormInput from "src/pages/components/AMFormInput";
import _, { set } from "lodash";
import { getItemDetails } from "src/services/INV/invService";
import { getCaption } from "src/utils/dictionary";

const Chip = styled(MuiChip)(spacing);

function InvTrxFooter({ formControls, tableData, title, setTableData , menuItemCode }) {
  const [columns, setColumns] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [summary, setSummary] = useState({
    rowsCount: 0,
    sumGrossAmt: 0,
    sumTotalTaxAmt: 0,
    sumNetAmt: 0,
  });

  //initColumns;
  useEffect(() => {
    const initColumns = () => {
      const columns = [];
      columns.push(renderColumnDataGrid("id", {}, { hide: true }));
      columns.push(renderColumnDataGrid("itemID", {}, { hide: true }));
      columns.push(renderColumnDataGrid("serial", formControls.serial));
      columns.push(renderColumnDataGrid("itemName", formControls.itemName));
      columns.push(renderColumnDataGrid("qty", formControls.qty));
      columns.push(renderColumnDataGrid("unitName", formControls.unitName));
      columns.push(renderColumnDataGrid("price", formControls.price));
      columns.push(
        renderColumnDataGrid("totalB4Discount", formControls.D_totalB4Discount)
      );
      columns.push(
        renderColumnDataGrid("discountAmt1", formControls.D_discountAmt1)
      );
      columns.push(
        renderColumnDataGrid("discountAmt2", formControls.D_discountAmt2)
      );
      columns.push(
        renderColumnDataGrid("discountAmt3", formControls.D_discountAmt3)
      );
      columns.push(renderColumnDataGrid("grossAmt", formControls.D_grossAmt));
      columns.push(
        renderColumnDataGrid("totalTaxAmt", formControls.D_totalTaxAmt)
      );
      columns.push(renderColumnDataGrid("netAmt", formControls.D_netAmt));
      columns.push(renderColumnDataGrid("notes", formControls.D_notes));

      return columns;
    };

    setColumns(initColumns());
  }, [formControls]);

  useEffect(() => {
    const newSummary = {
      rowsCount: 0,
      sumGrossAmt: 0,
      sumTotalTaxAmt: 0,
      sumNetAmt: 0,
    };

    if (tableData && tableData.length) {
      newSummary.rowsCount = tableData.length;
      newSummary.sumGrossAmt = parseAndRound(
        _.sumBy(tableData, function (o) {
          return parseAndRound(o.grossAmt);
        }),
        //It sums as string _.sumBy(tableData, "displayCredit"),
        4
      );
      newSummary.sumTotalTaxAmt = parseAndRound(
        _.sumBy(tableData, function (o) {
          return parseAndRound(o.totalTaxAmt);
        }),
        4
      );
      newSummary.sumNetAmt = parseAndRound(
        _.sumBy(tableData, function (o) {
          return parseAndRound(o.netAmt);
        }),
        4
      );
    }
    setSummary((state) => ({ ...state, ...newSummary }));
  }, [tableData]);

  const handleSelectedIndexChanged = (event, value, reason, fieldName) => {
    try {
      
      let colName = "";
      switch (fieldName) {
        case "itemID":
          colName = "itemName";
          break;
           case "unitID":
          colName = "unitName";
          break;
        default:
          break;
      }
      if (colName && value)
        setSubFormState({
          [colName]: value.textField,
          qty: subFormState?.qty || 1,
        });
      handleSelectedIndexChange(event, value, reason, fieldName);
    } catch (error) {
      throw error;
    }
  };

  //#region Add/Edit Form

  const {
    state: subFormState,
    errors: subFormErrors,
    handleSetState: setSubFormState,
    handleSetFullState: setSubFormFullState,
    handleSelectedIndexChange: handleSelectedIndexChange,
    renderFormInput,
    vaLidateFormData: defaultValidateSubFormData,
  } = useForm({
    menuItemCode: "",
    nextCodeField: "",
    getNextCodeFunc: null,
    getByIdFunc: null,
    saveFunction: null,
    deleteFunction: null,
    isSubForm: true,
    subFormControls: getSubFormContrlsObj(formControls, [
      "itemID",
      "discountAmt1",
      "discountAmt2",
      "discountAmt3",
      "itemDesc_Ar",
      "itemDesc_En",
      "price",
      "qty",
      "unitID",
      "totalB4Discount",
      "totalTaxAmt",
      "grossAmt",
      "netAmt",
      "notes",
    ]), //you have to filter because of validation schema
  });

 
  const gridXSmallItemProps = {
    lg: 1,
    // xs: 12,
    style: { paddingBottom: 1, paddingTop: 1 },
  };
   const gridSmallItemProps = {
    lg: 2,
    // xs: 12,
    style: { paddingBottom: 1, paddingTop: 1 },
  };

  // const handleCountrySelectedIndexChanged = (
  //   event,
  //   value,
  //   reason,
  //   fieldName
  // ) => {
  //   try {
  //     setSubFormState({ ...subFormState, lineCountryName: value.textField });
  //     handleSelectedIndexChange(event, value, reason, fieldName);
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  const handleItemChanged = (event, value, reason, fieldName) => {
    try {
      setSubFormState({unitID: ""});// reset unit when item changed because the options changed
      setSelectedItem(value);
      handleSelectedIndexChanged(event, value, reason, fieldName);
    } catch (error) {
      throw error;
    }
  };

 

  useEffect(() => {
    if (!subFormState.itemID) {
      return;
    }

    let isActive = true;

    const loadItemData = async () => {
      const res = await getItemDetails(menuItemCode, subFormState.itemID);
      if (!isActive) {
        return;
      }

      const itemData = res?.data || {};
      setSelectedItem(itemData);

      const basePrice = parseAndRound(itemData.price) || 0;
      const selectedUnit = itemData?.itemUnits?.find(
        (unit) => unit.valueField === subFormState.unitID
      );
      const factor = parseAndRound(selectedUnit?.factor) || 1;

      setSubFormState({
        price: basePrice * factor,
      });
    };

    loadItemData();

    return () => {
      isActive = false;
    };
  }, [subFormState.itemID]);

  // Update price when unit changed or item changed
  useEffect(() => {
    if (!selectedItem) {
      return;
    }

    const basePrice = parseAndRound(selectedItem.price) || 0;
    const selectedUnit = selectedItem?.itemUnits?.find(
      (unit) => unit.valueField === subFormState.unitID
    );
    const factor = parseAndRound(selectedUnit?.factor) || 1;

    setSubFormState({
      price: basePrice * factor,
    });
  }, [selectedItem, subFormState.unitID]);

// Calculate amounts when price or qty or discount or tax changed
useEffect(() => {
  
    console.log("FinChanged", subFormState);
    //TODO GET ITEM TAX PERCENT AND CALC TAX
    if (!subFormState.qty) {
       setSubFormState({
      totalB4Discount: 0,
      grossAmt: 0,
      totalTaxAmt: 0,
      netAmt: 0,
    });
      return;
    }
    
      if (!selectedItem) {
       setSubFormState({
      totalB4Discount: 0,
      grossAmt: 0,
      totalTaxAmt: 0,
      netAmt: 0,
      price: 0,
    });
      return;
    }
    const sumDiscount =
      parseAndRound(subFormState.discountAmt1) +
      parseAndRound(subFormState.discountAmt2) +
      parseAndRound(subFormState.discountAmt3);

    const totalB4Discount =
      parseAndRound(subFormState.qty) * parseAndRound(subFormState.price);
    const grossAmt =
      parseAndRound(subFormState.qty) * parseAndRound(subFormState.price) -
      sumDiscount;
    const totalTaxAmt = parseAndRound(
      grossAmt * parseAndRound(selectedItem?.VATPercent),
      2
    );
    const netAmt = grossAmt + parseAndRound(totalTaxAmt);

    // setSummary((state) => ({ ...state, ...newSummary }));
    setSubFormState({
      totalB4Discount,
      grossAmt,
      totalTaxAmt,
      netAmt,
    });
  }, [
    subFormState.qty,
    subFormState.price,
    selectedItem?.VATPercent,
    subFormState.discountAmt1,
    subFormState.discountAmt2,
    subFormState.discountAmt3,
  ]);
  const editForm = (
    <Grid container spacing={4}>
      {renderFormInput(
        "serial",
        Enums.ControlType.TextField,
        {
          disabled: true,
          style: { maxWidth: 100 },
        },
        { sm: 1 }
      )}
      <FormInput
        type={Enums.ControlType.AutoSearch}
        autoFocus={true}
        name={"itemID"}
        control={formControls["itemID"]}
        onChange={handleItemChanged}
        value={subFormState["itemID"] || ""}
        errorMsg={subFormErrors["itemID"]}
        gridItemProps={{ sm: 5 }}
      />
      {!(
        formControls["D_notes"] &&
        formControls["D_notes"].isHidden
      ) &&
        renderFormInput(
          "notes",
          Enums.ControlType.TextField,
          {},
          {
            xs: 12,
            lg: 12,
            xl: 12,
            style: { paddingBottom: 1, paddingTop: 1 },
          }
        )}
      <Grid item xs={12}>
        <Grid container spacing={4}>
          {renderFormInput(
            "qty",
            Enums.ControlType.TextField,
            {},
            gridXSmallItemProps
          )}
          <FormInput
            type={Enums.ControlType.AutoComplete}
            key={selectedItem?.itemID} // to reset it when item changed because the options changed
            options={selectedItem?.itemUnits || []}
            name={"unitID"}
            control={formControls["unitID"]}
            onChange={(event, value, reason) =>
              handleSelectedIndexChanged(event, value, reason, "unitID")
            }
            value={subFormState["unitID"] || ""}
            autoSelectSingleOption={true}
            errorMsg={subFormErrors["unitID"]}
            gridItemProps={gridSmallItemProps}
          />
          {renderFormInput(
            "price",
            Enums.ControlType.TextField,
            {},
            gridXSmallItemProps
          )}
          {renderFormInput(
            "totalB4Discount",
            Enums.ControlType.TextField,
            { disabled: true },
            gridSmallItemProps
          )}
          {renderFormInput(
            "discountAmt1",
            Enums.ControlType.TextField,
            {},
            gridXSmallItemProps
          )}
          {renderFormInput(
            "discountAmt2",
            Enums.ControlType.TextField,
            {},
            gridSmallItemProps
          )}
          {renderFormInput(
            "discountAmt3",
            Enums.ControlType.TextField,
            {},
            gridSmallItemProps
          )}
          {renderFormInput(
            "grossAmt",
            Enums.ControlType.TextField,
            {
              disabled: true,
            },
            gridSmallItemProps
          )}
          {renderFormInput(
            "totalTaxAmt",
            Enums.ControlType.TextField,
            { disabled: true },
            gridXSmallItemProps
          )}
          {renderFormInput(
            "netAmt",
            Enums.ControlType.TextField,
            {
              disabled: true,
            },
            gridSmallItemProps
          )}
        </Grid>
      </Grid>
    </Grid>
  );
  //#endregion
  const validateSubFormData = () => {
    if (defaultValidateSubFormData()) {
      const qty = parseAndRound(subFormState.qty);
      if (qty <= 0) {
        toast.error(getCaption("quantity_more_than_zero"));
        return false;
      }
      const price = parseAndRound(subFormState.price);
      if (price < 0) {
        toast.error(getCaption("price_more_or_equal_zero"));
        return false;
      }
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      {columns.length > 0 && (
        <AMFooterTable
          title={"title"}
          columns={columns}
          tableData={tableData}
          setTableData={setTableData}
          subFormState={subFormState}
          setSubFormState={setSubFormFullState}
          subFormErrors={subFormErrors}
          validateSubFormData={validateSubFormData}
          editForm={editForm}
        />
      )}
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item></Grid>
        <Grid item alignContent="right" justifyContent="right">
          <Grid container>
            <Grid item>
              <Chip
                label={
                  <Typography variant="button" component="h2">
                    {`Gross : ${parseAndRound(
                      summary.sumGrossAmt,
                      4
                    ).toLocaleString(undefined)}`}
                  </Typography>
                }
                color="secondary"
                m={1}
              />
            </Grid>
            <Grid item>
              <Chip
                label={
                  <Typography variant="button" component="h2">
                    {`Total Tax :     ${parseAndRound(
                      summary.sumTotalTaxAmt,
                      4
                    ).toLocaleString(undefined)}`}
                  </Typography>
                }
                color="secondary"
                m={1}
              />
            </Grid>
            <Grid item>
              <Chip
                label={
                  <Typography variant="button" component="h2">
                    {`Net :     ${parseAndRound(
                      summary.sumNetAmt,
                      4
                    ).toLocaleString(undefined)}`}
                  </Typography>
                }
                color="secondary"
                m={1}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
export default InvTrxFooter;
